import { upperFirst, camelCase } from 'lodash'
import { plural } from 'pluralize'

const upperCase = resource => upperFirst(camelCase(resource))
const pluralUpperCase = resource => plural(upperCase(resource))

export { upperCase, pluralUpperCase }
